export const typeKelasList = [
  {
    name: "TamanClass+",
    value: "TP",
  },
  {
    name: "TamanClass Seikhlasnya",
    value: "TS",
  },
  {
    name: "AfterClass+",
    value: "AP",
  },
  {
    name: "AfterClass Seikhlasnya",
    value: "AS",
  },
]
